// Parcelas de acordo que precisam de boleto (#6205). Regra pura, usada pela aba
// "Para emitir" de Parcelamentos e pelo aviso no sino (efetivar-parcelamentos).
//
// Decisão de 09/10/2026: o sistema NÃO emite sozinho — só aponta. Entra aqui a
// parcela cuja fatura já existe (o acordo passou a valer), ainda sem boleto, que
// vence dentro da janela (10 dias) ou já venceu, de acordo que ainda vale.

export const DIAS_ANTES_EMITIR = 10;
const ACORDO_VALE = new Set(['ativo', 'em_atraso']);

export interface LinhaParaEmitir {
  parcela_id: string;
  parcelamento_id: string;
  numero_parcela: number;
  data_vencimento: string;
  valor: number;
  fatura_id: number;
  cliente: string;
  uc: string;
  criado_por: string | null;
  /** Negativo = já venceu sem boleto. */
  dias_para_vencer: number;
}

const diasEntre = (de: string, ate: string) =>
  Math.round((Date.parse(`${ate}T00:00:00Z`) - Date.parse(`${de}T00:00:00Z`)) / 86_400_000);

export function selecionarParaEmitir(
  linhas: Array<{
    id: string; parcelamento_id: string; numero_parcela: number; data_vencimento?: string | null; valor?: number | null;
    status?: string | null; tipo?: string | null; fatura_id?: number | null;
    acordo?: { status?: string | null; cliente_nome_snapshot?: string | null; uc_codigo_snapshot?: string | null; criado_por?: string | null } | null;
    fatura?: { num_cobranca_boleto?: string | null; status_fatura?: string | null; status_boleto_vigor?: string | null } | null;
  }>,
  hoje: string,
  dias = DIAS_ANTES_EMITIR,
): LinhaParaEmitir[] {
  return linhas
    .filter((l) => {
      if (!l.fatura_id || !l.data_vencimento || !l.fatura) return false;
      // Parcela sem valor (acordo antigo, anterior ao cronograma com valores) não vira boleto.
      if (!(Number(l.valor) > 0)) return false;
      if (!ACORDO_VALE.has(String(l.acordo?.status || ''))) return false;
      if (['pago', 'cancelado'].includes(String(l.status || '').toLowerCase())) return false;
      if (l.fatura.num_cobranca_boleto) return false;
      const sf = String(l.fatura.status_fatura || '');
      if (sf === 'Excluído' || sf.startsWith('Cancelad')) return false;
      if (/^(pago|quitado|cancelad)/i.test(String(l.fatura.status_boleto_vigor || ''))) return false;
      return diasEntre(hoje, l.data_vencimento) <= dias;
    })
    .map((l) => ({
      parcela_id: l.id,
      parcelamento_id: l.parcelamento_id,
      numero_parcela: l.numero_parcela,
      data_vencimento: l.data_vencimento!,
      valor: Number(l.valor || 0),
      fatura_id: l.fatura_id!,
      cliente: String(l.acordo?.cliente_nome_snapshot || ''),
      uc: String(l.acordo?.uc_codigo_snapshot || ''),
      criado_por: l.acordo?.criado_por ?? null,
      dias_para_vencer: diasEntre(hoje, l.data_vencimento!),
    }))
    .sort((a, b) => a.dias_para_vencer - b.dias_para_vencer);
}

/** Select do PostgREST que traz o que `selecionarParaEmitir` precisa. */
export const SELECT_PARA_EMITIR =
  'id, parcelamento_id, numero_parcela, data_vencimento, valor, status, tipo, fatura_id, '
  + 'acordo:parcelamentos!inner(status, cliente_nome_snapshot, uc_codigo_snapshot, criado_por), '
  + 'fatura:faturas(num_cobranca_boleto, status_fatura, status_boleto_vigor)';
